module.exports = __webpack_public_path__ + "img/sfour.4c72747f.png";